<template>
  <base-page-layout title="Desempenho" :filters="['periodo']" :filtersQuantity="filtersQuantity">
    <app-metrics />
    <usuarios-ativos :metrics-period="metricsPeriod" />
    <usuarios-ativos-por-loja :metrics-period="metricsPeriod" />
    <v-row class="mb-1 mt-1 flex-wrap">
      <v-col class="column">
        <acessos-por-pagina :metrics-period="metricsPeriod" />
      </v-col>
      <v-col class="column">
        <dia-semana-maior-acesso :metrics-period="metricsPeriod" />
      </v-col>
    </v-row>
    <cadastros-app :metrics-period="metricsPeriod" />
    <sessoes-por-genero-idade :metrics-period="metricsPeriod" />
    <acessos-por-hora :metrics-period="metricsPeriod" />
  </base-page-layout>
</template>

<script>
import { mapState } from 'vuex'
import BasePageLayout from '@/components/BasePageLayout.vue'
import UsuariosAtivos from '@/modules/mobile/desempenho/views/components/UsuariosAtivos'
import AcessosPorPagina from '@/modules/mobile/desempenho/views/components/AcessosPorPagina'
import UsuariosAtivosPorLoja from '@/modules/mobile/desempenho/views/components/UsuariosAtivosPorLoja'
import DiaSemanaMaiorAcesso from '@/modules/mobile/desempenho/views/components/DiaSemanaMaiorAcesso'
import CadastrosApp from '@/modules/mobile/desempenho/views/components/CadastrosApp'
import AcessosPorHora from '@/modules/mobile/desempenho/views/components/AcessosPorHora'
import SessoesPorGeneroIdade from '@/modules/mobile/desempenho/views/components/SessoesPorGeneroIdade'
import AppMetrics from '@/modules/mobile/desempenho/views/components/AppMetrics.vue'

export default {
  components: {
    DiaSemanaMaiorAcesso,
    AcessosPorPagina,
    BasePageLayout,
    UsuariosAtivos,
    UsuariosAtivosPorLoja,
    CadastrosApp,
    AcessosPorHora,
    SessoesPorGeneroIdade,
    AppMetrics,
  },
  data() {
    return {
      filtersQuantity: 0,
    }
  },
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    metricsPeriod() {
      return this.stateFilters.periodo === 'Mensal' ? 'MONTHLY' : 'YEARLY'
    },
  },
}
</script>

<style lang="scss" scoped>
.column {
  min-width: 400px;
}
</style>
